module.exports = __webpack_public_path__ + "static/media/baner_premium_training.9b1a694f.jpg";